'use es6';

import { unique, intersection } from 'underscore';
import { arrayToKeyMirror } from 'DesignData/lib/array';
import CssClassData from 'DesignData/models/css/CssClassData';

const getCssClassString = cssClass => {
  return typeof cssClass === 'string' ? cssClass.trim() : '';
};

const getCssClassArray = cssClass => {
  const cx = getCssClassString(cssClass);
  return cx.split(/\s+/).filter(Boolean);
};
/**
 * Takes a string of CSS classes and returns normalized data approximating a sorted set.
 *
 * @param {String}
 * @return {DesignData/models/css/CssClassData}
 */


export function createCssClassData(__cssClass) {
  const cssClass = getCssClassString(__cssClass);
  const order = getCssClassArray(cssClass);
  const classes = arrayToKeyMirror(order);
  return new CssClassData({
    order,
    classes
  });
}
/**
 * Returns the intersection of css class data the passed passed list of class data objects.
 *
 * @param {Array.<DesignData/models/css/CssClassData>} classDataList
 * @return {DesignData/models/css/CssClassData}
 */

export function intersectCssClassData(classDataList = []) {
  const allClasses = classDataList.map(data => {
    if (!(data instanceof CssClassData)) {
      throw new TypeError('Expected CssClassData models array in intersectCssClassData()');
    }

    return data.order;
  });
  const order = intersection(...allClasses);
  const classes = arrayToKeyMirror(order);
  return new CssClassData({
    order,
    classes
  });
}
/**
 * Returns a new class string with duplicate classes removed.
 *
 * @param {String}
 * @return {String}
 */

export function stripDuplicateClasses(__cssClass) {
  const cssClass = getCssClassString(__cssClass);

  if (cssClass.length === 0) {
    return cssClass;
  }

  const list = unique(getCssClassArray(cssClass));
  return list.join(' ');
}